import { lazy } from 'react';

import { PathwayModalRenderer } from '@/components/popups/PathwayModal';

import LicenseeLocationPicker from './LicenseeLocationPicker/LicenseeLocationPicker';

import { env } from '@/env';

const Banner = lazy(() => import('../Permissions/Banner'));

interface LayoutWrapperProps {
  children: React.ReactNode;
}

const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => (
  <>
    {env.REACT_APP_ENV !== 'prod' && <Banner />}
    {children}
    <LicenseeLocationPicker />
    <PathwayModalRenderer />
  </>
);

export default LayoutWrapper;
